import styles from "../Content.module.scss"

import React, { useEffect, useState } from "react"

import classNames from "classnames"

import { wowPartnerApi } from "../../../../../@shared/apis"
import { PartnerMenu } from "../../../../../@shared/apis/wowPartner"
import { useSchedule } from "../../../../../@shared/contexts"
import { useAiIssueCatchStore } from "../../../../../@shared/stores/sidebarStore"
import {
  AI_FRAME_PADDING_Y,
  AI_IFRAME_HEIGHT_CLOSED,
  AI_IFRAME_HEIGHT_OPEN,
  AiIssueCatchBody,
  AiIssueCatchTab,
  ContentExpandToggle,
} from "../AiIssueCatch"
import ShortForm from "../ShortForm"

type Tab = "AI 이슈 캐치" | "숏폼 / AI 요약"

// 숏폼 목록 높이를 AI 이슈 캐치 패널(iframe + 회색 프레임 상하 패딩)과 정확히 동일하게 맞춰
// 탭 전환 시 높이가 튀지 않게 한다.
const CONTENT_HEIGHT_OPEN = AI_IFRAME_HEIGHT_OPEN + AI_FRAME_PADDING_Y * 2
const CONTENT_HEIGHT_CLOSED = AI_IFRAME_HEIGHT_CLOSED + AI_FRAME_PADDING_Y * 2

function nullMenuList(otherLength: number) {
  return (
    <>
      {Array.from({ length: otherLength }).map((_, index) => (
        <div key={index}>
          <div className="customMenuBtn hasNoLink">메뉴 지정</div>
        </div>
      ))}
    </>
  )
}

const PaidContent = () => {
  const { schedule } = useSchedule()
  const streamerUsername = schedule?.user.username
  const [partnerMenu, setPartnerMenu] = useState<PartnerMenu[]>()
  const [selectedTab, setSelectedTab] = useState<Tab>("AI 이슈 캐치")
  // 숏폼 탭 클릭할 때마다 값을 바꿔 ShortForm의 refreshTrigger로 넘겨 API를 다시 호출한다. (리마운트 아님)
  const [shortFormRefreshKey, setShortFormRefreshKey] = useState(0)
  const { isOpen } = useAiIssueCatchStore() as { isOpen: boolean }
  const contentHeight = isOpen ? CONTENT_HEIGHT_OPEN : CONTENT_HEIGHT_CLOSED
  // TODO [TO-BE] 추후 오픈시 주석 제거 후 사용 될 코드 (본방송 미니 플레이어 + 좌측 방송 화면에 한국경제 LIVE 방송)
  // const { setContentType } = useSetContentType()
  // const { active } = useSetIsMiniPlayerEnabled()

  useEffect(() => {
    if (!streamerUsername) return
    wowPartnerApi.getPartnerMenu(streamerUsername).then((result) => {
      setPartnerMenu(result.data.menuList)
    })
  }, [streamerUsername])

  const handleClick = () => {
    wowPartnerApi.getLiveInfo().then((result) => {
      if (result.data.programUrl) {
        // TODO [AS-IS] 추후 기능 제대로 오픈시 삭제할 코드
        window.open(result.data.programUrl, "_blank")
      }
    })

    // TODO [TO-BE] 추후 오픈시 주석 제거 후 사용 될 코드 (본방송 미니 플레이어 + 좌측 방송 화면에 한국경제 LIVE 방송)
    // setContentType(ContentType.youtube)
    // active()
  }

  const handleclickLinkToCustomUrl = (url: string) => () => {
    if (url === "") return
    window.open(url, "_blank")
  }

  return (
    <div>
      <div className={styles.paidTabBar}>
        <AiIssueCatchTab
          selected={selectedTab === "AI 이슈 캐치"}
          onSelect={() => setSelectedTab("AI 이슈 캐치")}
        />
        <a
          className={classNames({
            on: selectedTab === "숏폼 / AI 요약",
          })}
          title="숏폼 / AI 요약"
          style={{ width: "44%" }}
          onClick={(e) => {
            e.preventDefault()

            setSelectedTab("숏폼 / AI 요약")
            setShortFormRefreshKey((key) => key + 1)
          }}
        >
          숏폼 / AI 요약
        </a>
        {/* 확장/축소 토글: 어느 탭에도 속하지 않는 독립 버튼 (현재 탭 콘텐츠 높이 토글) */}
        <ContentExpandToggle />
      </div>
      {selectedTab === "AI 이슈 캐치" ? (
        <AiIssueCatchBody />
      ) : (
        <ShortForm
          refreshTrigger={shortFormRefreshKey}
          height={contentHeight}
          streamerId={schedule?.user.id}
          streamerNickname={schedule?.user.nickname}
        />
      )}
      {/* 파트너 메뉴 버튼 6개: 탭과 무관하게 항상 노출 */}
      <div className="tabC">
        <div className="stockVideoBtn">
          <div className="vodBtn" onClick={handleClick}>
            한국경제TV
            <br />
            생방송
          </div>
        </div>
        {/* 1. partnerMenu는 최대 5개까지 api를 통해 전달 */}
        {partnerMenu?.map((menu) => (
          <div key={menu.linkUrl}>
            <div
              onClick={handleclickLinkToCustomUrl(menu.linkUrl)}
              className={
                "customMenuBtn" + (menu.linkUrl === "" ? " hasNoLink" : "")
              }
            >
              {menu.menuName}
            </div>
          </div>
        ))}
        {/* 2. partnerMenu가 부족한 만큼 더미 버튼으로 채움 (5 - partnerMenu) */}
        {nullMenuList(5 - (partnerMenu?.length || 0))}
      </div>
    </div>
  )
}

export default PaidContent
